import {useEffect, useState} from "react";
import { STATUSES } from "_competition/const";
import {API, Card, Competition, CompetitionAPI, Endpoints} from "@brg/api";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";
import { useRouteMatch } from "react-router-dom";


export const useGetCompetitionNominations = (competitionId: string, disabled?: boolean, statuses?: number[]) => {
    const isEditPage = !!useRouteMatch('/competition-edit');
    const [nominations, setNominations] = useState<Competition<'Local'>[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const { i18n: {language} } = useTranslation();
    const profile = useProfile();

    useEffect(() => {
        if (competitionId && !disabled) {
            setIsLoading(true);
            try {
                CompetitionAPI.GetList({
                    parentCompetitionId: competitionId,
                    initTags: true,
                    initWinner: true,
                    competitionStatus: isEditPage
                      ? [
                        STATUSES.Draft,
                        STATUSES.Open,
                        STATUSES.Announcement,
                        STATUSES.Summarizing,
                        STATUSES.Voting,
                        STATUSES.Completed,
                        STATUSES.Archived,
                        STATUSES.LonglistFormation,
                      ]
                      : (statuses || [
                        STATUSES.Open,
                        STATUSES.Announcement,
                        STATUSES.Summarizing,
                        STATUSES.Voting,
                        STATUSES.Completed,
                        STATUSES.Archived,
                        STATUSES.LonglistFormation,
                      ]),
                    sort: 3,
                })
                .then((res) => res.json())
                .then((res) => {
                    setIsLoading(false);
                    setNominations(API.toLang<Competition<'Local'>[]>(res?.data, language))
                })
            }
            catch (_e) {
                setIsLoading(false);
                setError(true)
            }
        }
    }, [language, profile?.accountId, disabled, isEditPage, statuses, competitionId])

    return {nominations, isLoading, error}
}

import {useEffect, useState} from "react";
import { STATUSES } from "_competition/const";
import {API, Card, Competition, CompetitionAPI, Endpoints} from "@brg/api";
import {useTranslation} from "react-i18next";
import {useProfile} from "@brg/auth";
import { useRouteMatch } from "react-router-dom";


export const useGetCompetitionNominations = (competitionId: string, disabled?: boolean, statuses?: number[]) => {
    const isEditPage = !!useRouteMatch('/competition-edit');
    const [nominations, setNominations] = useState<Competition<'Local'>[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const { i18n: {language} } = useTranslation();
    const profile = useProfile();

    useEffect(() => {
        if (competitionId && !disabled) {
            setIsLoading(true);
            try {
                CompetitionAPI.GetList({
                    parentCompetitionId: competitionId,
                    initTags: true,
                    initWinner: true,
                    competitionStatus: isEditPage
                      ? [
                        STATUSES.Draft,
                        STATUSES.Open,
                        STATUSES.Announcement,
                        STATUSES.Summarizing,
                        STATUSES.Voting,
                        STATUSES.Completed,
                        STATUSES.Archived,
                        STATUSES.LonglistFormation,
                      ]
                      : (statuses || [
                        STATUSES.Open,
                        STATUSES.Announcement,
                        STATUSES.Summarizing,
                        STATUSES.Voting,
                        STATUSES.Completed,
                        STATUSES.Archived,
                        STATUSES.LonglistFormation,
                      ]),
                    sort: 3,
                })
                .then((res) => res.json())
                .then((res) => {
                    setIsLoading(false);
                    setNominations(API.toLang<Competition<'Local'>[]>(res?.data, language))
                })
            }
            catch (_e) {
                setIsLoading(false);
                setError(true)
            }
        }
    }, [language, profile?.accountId, disabled, isEditPage, statuses, competitionId])

    return {nominations, isLoading, error}
}

